import React from 'react';
import DOMPurify from 'dompurify';

function ContentSection({ section, altBg }) {
  // Sikrer at vi ikke krasjer hvis 'value' er tom eller feilformatert
  let data = {};
  try {
    data = JSON.parse(section.value || '{}');
  } catch (e) {
    console.error("Kunne ikke parse seksjonsdata:", e, section.value);
    // Fallback-data for å unngå krasj
    data = { title: 'Feil i innhold', text: 'Vennligst sjekk data i admin-panelet.' };
  }

  const TextContent = () => (
    <div className="feature-text">
      <h2>{data.title}</h2>
      {/* Bruker dangerouslySetInnerHTML for å tolke HTML fra Rich Text Editor */}
      <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.text) }} />
    </div>
  );

  const ImageContent = () => (
    data.imageUrl ? (
      <div className="feature-image">
        <img src={data.imageUrl} alt={data.title} />
      </div>
    ) : null
  );

  return (
    <section className={`page-section feature-section ${altBg ? 'alt-bg' : ''}`}>
      <div className={`feature-content-container ${data.layout}`}>
        {(data.layout === 'image_above' || data.layout === 'image_left' || data.layout === 'image_right') && <ImageContent />}
        <TextContent />
        {data.layout === 'image_below' && <ImageContent />}
      </div>
    </section>
  );
}

export default ContentSection;